module.exports = __webpack_public_path__ + "static/media/edit.28784bc2.SVG";